<template>
  <v-card
    :elevation="elevation"
    class="rounded-circle pa-0"
    :width="chipSize"
    :height="chipSize"
    :max-height="chipSize"
    :to="to"
  >
    <v-row justify="center" align="center" class="w-full h-full" no-gutters>
      <Logo :size="size" :color="color" :lucid="lucid" />
    </v-row>
  </v-card>
</template>

<script>
import Logo from "./Logo";
export default {
  components: { Logo },
  props: {
    elevation: { default: 2 },
    size: { default: "50" },
    to: { type: Object, default: () => ({ name: "index" }) },
    color: { type: String },
    lucid: { type: Boolean, default: true },
  },
  computed: {
    chipSize() {
      return Number(this.size) + 4;
    },
  },
};
</script>
